<template>
  <div>
    <Space :pheight="spacing" />
    <section class="Indent">
      <div @click="toggle(questionIndex)" class="ClickableWrapper">
        <HStack :pstyle="{ alignItems: 'center' }">
          <div class="SectionQuestion">{{ name }}</div>
          <Spacer />
          <div class="Button">
            <div class="HLine" :style="{ '--h': lineWH }" />
            <div v-show="!view" class="VLine" :style="{ '--h': lineWH }" />
          </div>
        </HStack>
      </div>
      <div class="Parent">
        <template v-for="(a, i) in data">
          <div
            v-show="view"
            v-if="a.type === 'Paragraph'"
            :class="a.type"
            class="SectionAnswer"
            :key="a.text"
          >
            {{ a.text }}
          </div>
          <div
            v-show="view"
            v-if="a.type === 'BulletList'"
            :class="a.type"
            :data-index="i"
            class="SectionAnswer_bullet_list"
            :key="a.text"
          >
            <span style="margin-left: 2em; display: list-item">{{
              a.text
            }}</span>
          </div>
          <div
            v-show="view"
            v-if="a.type === 'ImageList'"
            :class="a.type"
            class="SectionAnswer"
            :key="a.text"
          >
            <div class="symbolImageWrapper">
              <img
                class="symbolImage"
                :src="require(`../../assets/faq/${faqIcons[i]}`)"
              />
              <div>{{ a.text }}</div>
            </div>
          </div>
        </template>
      </div>
      <Space :pheight="spacing" />
    </section>
    <div class="Line" />
  </div>
</template>
<script>
import i18n from '../../i18n';
import { HStack, Spacer } from '../../layout/flexbox';
import Space from '../../layout/space';
import { sendAnalytics } from '../../shared/analytics';

const faqIcons = [
  'qwello-pin.svg',
  'roaming-pin.svg',
  'unavailable-pin.svg',
  'selected-pin.svg',
  'charging-pin.svg',
  'nav-ic.svg',
  'microphone-ic.svg',
  'favs-ic.svg',
  'menu-ic.svg',
  'users-position.png',
  'recenter-ic.svg',
  'reorient-ic.svg',
  'reserved-ic.svg',
  'charging-ic.svg',
];
export default {
  components: {
    HStack,
    Spacer,
    Space,
  },
  props: ['data', 'name', 'metaData', 'analyticsPermitted', 'questionIndex'],
  data() {
    return {
      view: false,
      spacing: '40px',
      lineWH: '20px',
      faqIcons,
      analytics: { sent: false },
    };
  },
  methods: {
    toggle(index) {
      this.view = !this.view;
      if (this.analytics.sent || !this.analyticsPermitted) {
        return;
      }

      sendAnalytics('tap_faq', { title: i18n.t(this.metaData + index) });
      this.analytics.sent = true;
    },
    onResize() {
      if (window.innerWidth < 768 && this.spacing !== '22.5px') {
        this.spacing = '22.5px';
        this.lineWH = '16px';
      } else if (window.innerWidth > 768 && this.spacing !== '40px') {
        this.spacing = '40px';
        this.lineWH = '20px';
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scoped>
.Indent {
  box-sizing: border-box;
  --faq-spacing: 0.8em;
  --q-font-size: 70px;
  --faq-q-f-size: 20px;
  --faq-q-f-weight: 800;
  --faq-a-f-size: 20px;
  --faq-indent-p: 0 3em 0 3em;
  --h: 20px;
}
ul {
  padding-left: 2em;
}
li {
  list-style: disc;
  position: relative;
}
.ClickableWrapper {
  cursor: pointer;
}
.SectionQuestion {
  font-size: var(--faq-q-f-size);
  font-weight: 800;
  max-width: 90%;
}
.SectionAnswer {
  margin-top: var(--faq-spacing);
  font-weight: 400;
  font-size: var(--faq-a-f-size);
  max-width: 1200px;
}
.SectionAnswer_bullet_list[data-index='1'] {
  margin-top: 30px;
}
.SectionAnswer_bullet_list {
  font-weight: 400;
  font-size: var(--faq-a-f-size);
  max-width: 1200px;
}
.Paragraph {
  padding-top: 0.4em;
}
.Parent > .SectionAnswer {
  margin-top: 30px;
}
.symbolImageWrapper {
  display: flex;
  align-items: center;
}

.symbolImage {
  padding-right: 1em;
}
.Indent {
  padding: var(--faq-indent-p);
}
.Button {
  display: grid;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  cursor: pointer;
}
.HLine {
  grid-area: 1 / 1;
  width: var(--h);
  height: 2px;
  background: #2b4047;
}
.VLine {
  grid-area: 1 / 1;
  width: 2px;
  height: var(--h);
  justify-self: center;
  background: #2b4047;
}
.Line {
  width: 100%;
  height: 1px;
  background: #c8d1d3;
}

@media (max-width: 800px) {
  .Indent {
    --q-font-size: 60px;
    --faq-indent-p: 0 1.4em 0 1.4em;
  }
}
@media (max-width: 600px) {
  .Indent {
    --q-font-size: 55px;
  }
  .SectionAnswer {
    max-width: 90%;
    margin: 0 auto;
  }
}
@media (max-width: 550px) {
  .Indent {
    --q-font-size: 30px;
    --faq-a-f-size: 14px;
    --faq-q-f-size: 14px;
    --faq-indent-p: 0;
  }
  .symbolImage {
    width: 50px;
    height: 50px;
  }
}
</style>
